<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="addNews">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list class="v-list--booking" v-if="getNews.items.length > 0">
            <v-list-item
                :key="news.id"
                @click="editNews(news.id)"
                v-for="news in getNews.items"
                :class="`v-list--booking_state f-width ${$route.params.newsEventId === news.id ? 'active' : ''}`"
            >
                <v-list-item-title v-text="news.name"/>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon @click.prevent="NewsEventChangeState(news.id, news.status)">
                                <v-icon>{{ news.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Статус</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import News from '../../../api/event'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'newsEventsNavigation',
        components: { Empty },
        methods: {
            addNews () {
                this.$router.push({ name: 'addNews' })
            },
            editNews (id) {
                this.$router.push({
                    name: 'editNews',
                    params: { newsEventId: id }
                })
            },
            NewsEventChangeState (id, status) {
                News
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('newsEventChangeState', response.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус новости/события изменен успешно',
                            color: 'info'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: mapGetters([
            'getNews'
        ])
    }
</script>
